import { getAuthHeaders } from './authHeaders';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

class LocationsAPI {
  static async getCities() {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/locations/cities`, { headers });
    if (!response.ok) {
      if (response.status === 401) throw new Error('NOT_AUTHENTICATED');
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  static async getDistricts(cityId) {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/locations/districts?city_id=${encodeURIComponent(cityId)}`, { headers });
    if (!response.ok) {
      if (response.status === 401) throw new Error('NOT_AUTHENTICATED');
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  static async getNeighborhoods(districtId) {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/locations/neighborhoods?district_id=${encodeURIComponent(districtId)}`, { headers });
    if (!response.ok) {
      if (response.status === 401) throw new Error('NOT_AUTHENTICATED');
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }
}

export default LocationsAPI;
